module.exports = __webpack_public_path__ + "img/fallback-slide.2560x1280.de.657599c1.png";